module.exports = __webpack_public_path__ + "img/bg_poster3.32c811b9.png";